export const WEB_SOCKET_EVENTS = {
  NEW_ISSUE_RECORDER: 'new-issue-recorded',
  NEW_EXTENSION_INSTALL_RECORDED: 'new-extension-install-recorded',
  NEW_ANNOUNCEMENT_RECORDED: 'new-announcement-recorded',
  KNOWLEDGE_STATUS_UPDATED: 'knowledge-status-updated'
}